export class LoginOrPasswordError extends Error {
    constructor() {
        super('Invalid user name or password.');
        Object.setPrototypeOf(this, LoginOrPasswordError.prototype);
    }
}

export class AccessDeniedError extends Error {
    constructor() {
        super('Access denied');
        Object.setPrototypeOf(this, AccessDeniedError.prototype);
    }
}
